import { AxiosMonitoringServiceObj } from "../../Configurations/axios-ameya-setup";
import { fetchAccountId, fetchSubscriberId, fetchSubscriptionId } from "../../../utils/GetAccountDetails"

class AmeyaBackendApi {

    constructor() {
        this.accountId = null;
        this.subscribeId = null;
        this.subscriptionId = null;
    }

    async initialize() {
        this.accountId = await fetchAccountId();
        this.subscriberId = await fetchSubscriberId();
        this.subscriptionId = await fetchSubscriptionId();
    }

    createJob = async (reqObj, project_id) => {
        await this.initialize();
        return AxiosMonitoringServiceObj.post(`/subscriber_id/${this.subscriberId}/subscription_id/${this.subscriptionId}/account_id/${this.accountId}/project_id/${project_id}/function/monitoring/event/job-create`, reqObj)
    }

    getJobStatus = async (job_id) => {
        await this.initialize();
        return AxiosMonitoringServiceObj.get(`/function/monitoring/event/job-status?job_id=${job_id}`)
    }

    deleteJobs = async (reqObj) => {
        await this.initialize();
        return AxiosMonitoringServiceObj.post(`function/monitoring/event/job-delete`, reqObj)
    }

}

const MonitoringServiceApi = new AmeyaBackendApi();
export default MonitoringServiceApi;